import { FaBirthdayCake, FaCalendarAlt, FaCubes, FaReceipt, FaShoppingCart, FaThList } from "react-icons/fa";

export const icon = {
    Birthday : <FaBirthdayCake className="birthdayIcon" title='Birthday'/>,
    Anniversary:<FaCalendarAlt class ="anniversaryIcon" title="Anniversary"/>,
    Receivable:<FaShoppingCart className="ordersIcon" title="Receivable" />,
    Payable:<FaReceipt className="todayPayableIcon" title="Payable"/>,
    Orders:<FaShoppingCart className="ordersIcon" title="Orders" />,
    'Stock Alert':<FaCubes  className="stockAlertIcon" title="Stock Alert"/>,
    Inventory:<FaCubes className="stockAlertIcon" title="Inventory"/>,
    Others:<FaThList  className="stockVerificationIcon" title="Others"/>
  }


  export   function timeSince(date1) {
    var date = new Date(date1);
    var seconds = Math.floor((new Date() - date) / 1000);
    var interval = seconds / 31536000;

    if (interval > 1) {
        return Math.floor(interval) + " year";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
        return Math.floor(interval) + " month";
    }
    interval = seconds / 604800;
    if (interval > 1) {
        return Math.floor(interval) + " w";
    }
    interval = seconds / 86400;
    if (interval > 1) {
        return Math.floor(interval) + " day";
    }
    interval = seconds / 3600;
    if (interval > 1) {
        return Math.floor(interval) + " hr";
    }
    interval = seconds / 60;
    if (interval > 1) {
        return Math.floor(interval) + " min";
    }
    if (seconds < 5) {
        return " now";
    } else {
        return Math.floor(seconds) + " sec";
    }
}